const getSeverityColor = (importance: string) => {
  const importanceLower = importance.toLowerCase();

  if (importanceLower.includes('high')) {
    return 'var(--mantine-color-red-6)';
  }

  if (importanceLower.includes('medium')) {
    return 'var(--mantine-color-yellow-6)';
  }

  if (importanceLower.includes('low')) {
    return 'var(--mantine-color-green-6)';
  }

  return 'var(--mantine-color-blue-6)';
};

export default getSeverityColor;
